import React from "react";
import { Steps } from "antd";
import {
  UserOutlined,
  AppstoreOutlined,
  FormOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";

const { Step } = Steps;

export default function StepHeader({ current }) {
  return (
    <Steps current={current} size="small" style={{ marginBottom: 30 }}>
      <Step title="Basics" icon={<UserOutlined />} />
      {/* <Step title="Code List" icon={<UserOutlined />} /> */}
      <Step title="Select Package" icon={<AppstoreOutlined />} />
      <Step title="Additional Details" icon={<FormOutlined />} />
      <Step title="Review & Confirm" icon={<CheckCircleOutlined />} />
    </Steps>
  );
}
